import api from "utils/api";

export const getProduct = async (idOrParams) => {
    try {
        if (typeof idOrParams === "number" || typeof idOrParams === "string") {
            const res = await api.get(`/buccl_main/api/v1/products/${idOrParams}/`);
            return res.data;
        } else {
            const res = await api.get(`/buccl_main/api/v1/products/`, {
                params: idOrParams,
            });
            return res.data;
        }
    } catch (err) {
        console.error("getProduct API 에러:", err);
        return null;
    }
};

export const getProductShippingFee = async (product_id) => {
    try {
        const res = await api.get(
            `/buccl_main/api/v1/products/${product_id}/shipping-fee/`
        );
        return res.data;
    } catch (err) {
        console.error("getProductDetail API 에러:", err);
        return null;
    }
};

export const updateProductShippingFee = async (product_id, params) => {
    try {
        const res = await api.post(
            `/buccl_main/api/v1/products/${product_id}/shipping-fee/`,
            params
        );
        return res.data;
    } catch (err) {
        console.error("updateProductShippingFee API 에러:", err);
        return null;
    }
};
